import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {map} from "rxjs/operators";
import {MailToSharedService} from "../services/mail-to-shared.service";
import {MAIL_TO_SHARED_ACTION, MailToSharedActions} from "../actions/mail-to-shared-actions";

@Injectable()
export class MailToSharedEffects {
  constructor(private actions$: Actions, private mailToSharedService: MailToSharedService) {}

  mailTo$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<MailToSharedActions>(MAIL_TO_SHARED_ACTION),
        map((action) => {
          if (action.payload) {
            this.mailToSharedService.mailToShared(action.payload);
          }
        })
      ),
    { dispatch: false }
  );
}
